import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useNotificationList(data = {}) {
  const { enabled = false, queryParams = '' } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getNotificationList() {
    return privateFetch.get(`/v1/admin/notification`).then((res) => {
      return res.data;
    });
  }

  return useQuery(['notification-lists', { data }], getNotificationList, {
    enabled,
    keepPreviousData: true,
  });
}

export default useNotificationList;
